import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private loadingCount = 0;
  private readonly keyedRequests = new Set<string>();
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading = this.isLoadingSubject.asObservable();

  /** Avoid flicker when show/hide are called in quick succession. */
  private readonly minVisibleMs = 380;
  private shownAt = 0;
  private hideDelayTimer?: ReturnType<typeof setTimeout>;

  show(requestKey?: string): void {
    if (this.hideDelayTimer) {
      clearTimeout(this.hideDelayTimer);
      this.hideDelayTimer = undefined;
    }

    const wasLoading = this.loadingCount > 0 || this.keyedRequests.size > 0;
    if (requestKey) {
      this.keyedRequests.add(requestKey);
    } else {
      this.loadingCount++;
    }
    if (!wasLoading) {
      this.shownAt = Date.now();
      this.setLoading(true);
    }
  }

  hide(requestKey?: string): void {
    if (requestKey) {
      if (!this.keyedRequests.delete(requestKey)) return;
    } else {
      if (this.loadingCount <= 0) return;
      this.loadingCount--;
    }

    if (this.loadingCount > 0 || this.keyedRequests.size > 0) {
      return;
    }

    const elapsed = Date.now() - this.shownAt;
    const wait = Math.max(0, this.minVisibleMs - elapsed);

    this.hideDelayTimer = setTimeout(() => {
      if (this.loadingCount === 0 && this.keyedRequests.size === 0) {
        this.setLoading(false);
      }
      this.hideDelayTimer = undefined;
    }, wait);
  }

  private setLoading(isLoading: boolean): void {
    setTimeout(() => this.isLoadingSubject.next(isLoading));
  }
}
